module.exports = __webpack_public_path__ + "static/img/Inspection2.640a284d.png";